import { Component } from 'react';
import Image from 'Components/Common/Image';
import { validator } from 'Helpers/validator';
import DragUpload from 'Components/Common/Dragupload';
import LoadingOverlay from 'react-loading-overlay';
import { Link } from 'react-router-dom';
import { FILE_TYPE } from 'Helpers/apiurl';
import FileUploadWrapper from '../FileUploadWrapper';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';
import { teamConstants } from 'Constants';
import AddTeamUsers from '../AddTeamUsers';
import ExistedTeamUsers from '../ExistedTeamUsers';

class EditManageBroadcast extends Component {
  constructor(props) {
    super(props);
    const model = {
      teamName: '',
      aboutTeam: '',
      fileName: '',
      isActive: 1,
      loading: false,
      image: '',
      teamMembers: [],
      searchParam: '',
      showError: false,
      editErrorElement: '',
      inValidFormatMeaasge:'',
      inValidFormatpopup:'',
      searchVal: '',
      showOrgError: false,
      uploadImageError: '',
      addTeamUsersPopup: false
    };
    this.state = model;
    this.validator = validator.getInstance();
  }

  validation = (e) => {
    if (!e.target.dataset.validation || !e.target.dataset.check) {
      return;
    }
    const inputRules = e.target.dataset.validation.split(',');
    const elementObject = {
      formId: 'edit-team-form',
      message: e.target.dataset.error,
      elementName: e.target.name,
      elementValue: e.target.value,
    };
    this.validator.validate(elementObject, inputRules);
  };

  componentDidMount() {
    const { match: { params: { id: broadcastTeamId } } } = this.props;
    this.props.fetchEditObj(broadcastTeamId);
  }

  handleCheckBoxChange = () => {
    this.setState({ isActive: !this.state.isActive & 1 });
  };

  redirectToGrid = () => {
    this.setState(
      {
        teamMembers: [],
      },
      () => {
        this.props.history.push(`/broadcast/team`);
      }
    );
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    if(name === 'aboutTeam' && value?.length > teamConstants.ABOUT_TEAM_CHAR_LENGTH){
      return;
    }
    this.setState({ [ name ]: value });
  };

  handleAddTeamMembers = (selectedMembers) => {
    const { teamMembers } = this.state;
    let updateMembers = [ ...teamMembers ];
    updateMembers = teamMembers.concat(Object.values(selectedMembers));
    this.setState({
      teamMembers: updateMembers,
    });
  }

  handleRemoveTeamMembers = (rest) => {
    let updateMembers = [];
    const removeIndex = this.state.teamMembers
        .map((item) => {
          return item.username;
        })
        .indexOf(rest.username);
    if(removeIndex > -1){
        this.state.teamMembers.splice(removeIndex, 1);
        updateMembers = this.state.teamMembers;
        this.setState({
          teamMembers: updateMembers,
        });
    }
  }

  modifiedAddOrRemoveButton = (username) => {
    const { teamMembers } = this.state;
    const isExists = teamMembers
      ? teamMembers.findIndex((member) => member.username === username)
      : -1;
    return isExists === -1 ? 'Add' : 'Delete';
  };

  static getDerivedStateFromProps(props, state) {
    if (props.id !== state.id) {
      const { id, teamName, aboutTeam, isActive, image, teamMembers } = props;
      return {
        id,
        teamName,
        aboutTeam,
        isActive,
        image,
        fileName: image,
        teamMembers
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    const { usersList = {} } = this.props;
    if (prevProps.error !== this.props.error) {
      if (this.props.error !== true && this.props.editErrorElement === '') {
        this.redirectToGrid();
      }
    }
    if (prevProps.editErrorElement !== this.props.editErrorElement) {
      this.setState({ editErrorElement: this.props.editErrorElement });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const formId = 'edit-team-form';
    const {
      id,
      teamName,
      aboutTeam,
      isActive,
      image,
      createdAt,
      teamMembers
    } = this.state;
    const teamUsers = teamMembers.map((item) => {
      return item[ 'username' ];
    });

    if(image === '') {
      return this.setState({ uploadImageError: 'Please upload image' });
    }
    this.setState({ showOrgError: false, uploadImageError: '' })
    // if (teamUsers.length === 0 && !isOrganisation) {
    if (teamUsers.length === 0) {
      this.setState({ showError: true });
    } else {
      this.setState({ showError: false }, () => {
        if (formId && !this.validator.checkBeforeSubmit(formId)) {
          this.props.updateTeam({
            id,
            teamName: teamName, //isOrganisation ? organisation : teamName,
            aboutTeam,
            isActive,
            createdAt,
            image,
            teamMembers: teamUsers
          }, this.props.filterVal);
        }
      });
    }
  };

  updateImage = (fileToken, fileName) => {
    this.setState({
      image: fileToken,
      fileName,
    });
  };

  removeProfileimage = () => {
    this.setState({
      image: '',
      fileName: '',
    });
  };
  
  handleimageError = ( error,message ) => {
    this.setState({ inValidFormatpopup:error,inValidFormatMeaasge:message })
  }

  handleInValidPopup = () => {
    this.setState({ inValidFormatpopup:false })
  }

  toggleAddTeamUsersPopup = () => {
    this.setState( { addTeamUsersPopup: !this.state.addTeamUsersPopup } );
  }

  render() {
    const {
      teamName,
      aboutTeam,
      image,
      inValidFormatMeaasge,
      inValidFormatpopup
    } = this.state;
    const { usersTotalRecords, usersCurrentPage, formLoading } = this.props;
    const dragUploadProps = {
      id: 'addadminupload',
      removeImage: this.removeProfileimage,
      updateImage: this.updateImage,
      requiredfield: 'requiredfield',
      type: FILE_TYPE.IMAGE,
      imageError: this.handleimageError,
      inputTypeFileComp: ( { fileInputProps } ) => { return <FileUploadWrapper fileInputProps={ fileInputProps } /> }
    };

    return (
      <>
        <div className='pageContainer_inner pb-15'>
            <LoadingOverlay
              active={ formLoading }
              spinner
              styles={ {
                wrapper: {
                  width: '100%',
                  textAlign: '-webkit-center',
                },
              } }
              text='Please wait...'
            ></LoadingOverlay>
          <div className='myprofile'>
            <div className='heading-block gap-10'>
              <div className='block_flex'><h4>Edit Team Broadcast</h4></div>
            </div>
            <div className='main-block loading-parent p-0'>
              <form id='edit-team-form' >
                <div className='pageContent'>
                  <div>
                    <div className='ctInputField'>
                      <label>
                        Team Name<sup>*</sup>
                      </label>
                      <input
                        type='text'
                        name='teamName'
                        value={ teamName }
                        data-validation={ [ 'requiredfield' ] }
                        data-error='Enter team name'
                        onBlur={ this.validation }
                        placeholder='Enter team name here!'
                        maxLength='25'
                        onChange={ this.handleChange }
                      />
                    </div>
                    <div className='ctInputField'>
                      <label>About Team</label>
                      <input
                        type='text'
                        name='aboutTeam'
                        className='team-ipout'
                        value={ aboutTeam }
                        placeholder={ `Enter about team here!` }
                        onChange={ this.handleChange }
                        maxLength={ teamConstants.ABOUT_TEAM_CHAR_LENGTH }
                      />
                      <p className='ctCharText'>{ `${ aboutTeam?.length || 0 }/${ teamConstants.ABOUT_TEAM_CHAR_LENGTH } Characters` }</p>
                    </div>
                    <div className='ctInputField'>
                      <label>Profile image<sup>*</sup></label>
                      <div className='profile-img-block'>
                        <div className='profile-image'>
                        <Image
                          checkNotFound={ this.removeProfileimage }
                          imageToken={ image }
                        />
                        </div>
                        {image === null && (
                        <DragUpload
                            { ...dragUploadProps }
                          />
                        )}
                        {image !== null && (
                          <DragUpload
                            { ...dragUploadProps }
                            requiredfield=''
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <ExistedTeamUsers 
                usersList={ this.props.usersList }
                usersCurrentPage={ usersCurrentPage }
                teamMembers={ this.state.teamMembers }
                handleRemoveTeamMembers = { this.handleRemoveTeamMembers }
                toggleAddTeamUsersPopup = { this.toggleAddTeamUsersPopup }
              />
              <div className='button_fixed_block'>
                <div>
                  <button
                    type='reset'
                    onClick={ this.redirectToGrid }
                    className='btn btn_outline'
                  >
                    Cancel
                  </button>
                  <button className='btn btn_primary' onClick={ this.handleSubmit }>Save</button>
                </div>
              </div>
            </div>
          </div>
          { this.state.addTeamUsersPopup && <AddTeamUsers 
            usersList={ this.props.usersList } 
            usersTotalRecords={ usersTotalRecords } 
            usersCurrentPage={ usersCurrentPage }
            teamMembers={ this.state.teamMembers } 
            fetchUsers={ this.props.fetchUsers }
            handleAddTeamMembers = { this.handleAddTeamMembers }
            toggleAddTeamUsersPopup = { this.toggleAddTeamUsersPopup }
          /> }
          { inValidFormatpopup &&
              <div className='seccess-popup'>
                <div className='content-wraper'>
                  <i className='popup_close' onClick={ this.handleInValidPopup }><Close/></i>
                  <p>
                    { inValidFormatMeaasge }
                  </p>
                  <div className='action'>
                    <Link to='#' onClick={ this.handleInValidPopup } className='btn btn_primary'>ok</Link>
                  </div>
                </div>
              </div>
            }
        </div>
      </>
    );
  }
}
export default EditManageBroadcast;
